module.exports = __webpack_public_path__ + "img/礼物.35eba78c.png";